
import { type FC, useMemo } from 'react'

import { IconStatsClose } from 'assets/svg/sprite'
import { LastPostInfo } from 'components-ref/molecules'
import { useGlobalVideo } from 'context/globalVideoContext'
import { usePreviewContext } from 'context/previewContext'
import { useOrientation } from 'helpers/helperHooks'
import { StoryPreviewModal } from 'pages/storyPreview'
import { type IPost } from 'types/interfaces/ITypes'

type Props = {
  post: IPost
  showControls: boolean
  isFirstPost: boolean
  hasNextPage: boolean
  isInViewport?: boolean
  minimizeFn: (fileIndex: number, type: string) => void
  toggleControls: () => void
  isLastPost?: boolean
  setIsOptionsNavOpen?: (val: boolean) => void
  activeStorySlide?: number | null
  setCurrentStorySlide?: (val: any) => void
  allPosts?: IPost[]
}

const SinglePostPreviewStory: FC<Props> = ({
  post,
  isInViewport,
  hasNextPage,
  isLastPost = false
}) => {

  const {
    selectedSlide,
    selectedPostType,
    minimized,
    clearModal
  } = usePreviewContext()

const {
  pause,
  stopLoading,
  getCurrentMedia
} = useGlobalVideo()

  const stories = useMemo(
    () =>
      [...(post.stories ?? [])].sort(
        (a, b) =>
          new Date(b.created_at).getTime() -
          new Date(a.created_at).getTime()
      ),
    [post.stories]
  )

  const activeSlide =
    typeof selectedSlide === 'number' && Number.isFinite(selectedSlide)
      ? Math.max(0, Math.min(selectedSlide, stories.length - 1))
      : 0

  const onClose = () => {
    const currentMedia = getCurrentMedia()

    if (currentMedia?.id.startsWith('story:')) {
      pause()
      stopLoading()
    }

    clearModal()
  }


  return (
    <>
      <div className="preview__close" onClick={onClose}>
        {minimized
          ? <IconStatsClose color="#A3A3A3" />
          : <IconStatsClose />
        }
      </div>

      <div className="preview__file--wrapper">
        <StoryPreviewModal
          stories={stories}
          startIndex={activeSlide}
          onClose={onClose}
          withCloseButton={false}
          isInViewport={isInViewport}
          homeFeed={true}
          userId={post.user?.id ?? post.user_id}
          username={post.user?.username}
          displayName={post.user?.display_name}
          avatar={post.user?.avatar?.url ?? null}
        />

        {isLastPost && !hasNextPage && <LastPostInfo />}
      </div>
    </>
  )
}

export default SinglePostPreviewStory
